import React, { memo } from 'react'

import { useTranslation } from 'react-i18next'
import HasPermissions from '../../../../../common-components/HasPermissions'

import ContracteeBrewersOverview from '../../../../ContracteeBrewersOverview'
import CustomerPortal from '../../../../CustomerPortal'
import History from '../../../../History'
import AcknowledgeInboundShipmentsReminderPopup from '../../../../AcknowledgeInboundShipmentsReminderPopup'


import {
  FUNCTIONALITY_THAT_NEEDS_PERMISSIONS_ACKNOWLEDGE_INBOUND_SHIPMENTS,
} from '../../../../../constants/permissions'

import {
  CUSTOMER_TYPES_CONTRACT_BREWER,
} from '../../../../../constants'

export default memo(({ // Why memo? See CODE_COMMENTS_253
  customerId,
}) => {
  const { t: translate } = useTranslation('common')
  return (
    <div>
      <ContracteeBrewersOverview
        customerId={customerId}
      />
      <CustomerPortal
        customerId={customerId}
        customerType={CUSTOMER_TYPES_CONTRACT_BREWER}
      />
      <History customerId={customerId} translate={translate} />
      <HasPermissions
        requiredPermissions={FUNCTIONALITY_THAT_NEEDS_PERMISSIONS_ACKNOWLEDGE_INBOUND_SHIPMENTS}
        renderIfHasPermissions={
          () => <AcknowledgeInboundShipmentsReminderPopup customerId={customerId} />
        }
      />
    </div>
  )
})
